/** @format */

import React, { useEffect } from 'react';
import Header from '../../components/common/Header';
import HeroSection from '../../components/ui/HeroSection';
import { useSEO } from '../../hooks/useSEO';
import { injectJsonLd } from '../../utils/jsonLd';
import { homeSchema } from '../../schema/home.schema';

const AboutSection = React.lazy(
	() => import('../../components/ui/AboutSection')
);
const WhatWeDoSection = React.lazy(
	() => import('../../components/ui/WhatWeDoSection')
);
const HowItWorks = React.lazy(() => import('../../components/ui/HowItWorks'));
const MentorsSection = React.lazy(
	() => import('../../components/ui/MentorsSection')
);
const BlogSection = React.lazy(() => import('../../components/ui/BlogSection'));
const TestimonialSection = React.lazy(
	() => import('../../components/ui/TestimonialSection')
);
const Footer = React.lazy(() => import('../../components/common/Footer'));

const LandingPage: React.FC = () => {
	useSEO({
		title: 'LLB360 | Structured LLB Exam Notes & Repeated Questions',
		description:
			'Master LLB exams with LLB360. Get structured notes, repeated question analysis, landmark cases & exam-focused legal study material in one uniform framework. Study smarter, score higher.',
		keywords:
			'LLB notes, law notes, LLB exam preparation, law exam notes, landmark cases, repeated questions, legal studies, Indian law, LLB360',
		canonical: 'https://www.llb360.com/',

		ogTitle: 'LLB360 | Structured LLB Exam Notes & Repeated Questions',
		ogDescription:
			'One-stop platform for LLB students. Structured notes, repeated questions, landmark cases & exam-focused legal content.',
		ogSiteName: 'LLB360',
		ogImage: 'https://www.llb360.com/og-llb360.webp',

		twitterTitle: 'LLB360 | Structured LLB Exam Notes & Repeated Questions',
		twitterDescription:
			'Ace your LLB exams with structured notes, repeated question analysis & landmark cases — only on LLB360.',
		twitterImage: 'https://www.llb360.com/og-llb360.webp',
	});

	useEffect(() => {
		injectJsonLd(homeSchema);
	}, []);

	return (
		<body className='bg-white p-0! overflow-x-hidden'>
			<Header />
			{/* Landing Page Content */}
			<main className='snap-y snap-mandatory overflow-y-auto'>
				<HeroSection />
				<React.Suspense
					fallback={<div className='h-20 bg-gray-100 animate-pulse' />}>
					<AboutSection />
					<WhatWeDoSection />
					<HowItWorks />
					<MentorsSection />
					<TestimonialSection />
					<BlogSection />
					<Footer />
				</React.Suspense>
			</main>
		</body>
	);
};

export default LandingPage;
